/*
 * @Author: huangzq
 * @Date: 2020-04-15 16:22:12
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-06-12 15:09:18
 * @Desc: 课件列表组件-每一块
*/
<template>
  <div class="import-list-item">
    <div class="info-line">
      <div class="left">
        <template v-if="item.materialType==='1'">
          <mk-image
            ref="mkImageRef"
            :src="item.cover+'?x-oss-process=image/quality,Q_90/resize,w_100'"
            :preview-src-list="[item.cover]"
          />
        </template>
        <template v-else-if="item.materialType==='2'">
          <video
            class="video"
            :src="item.url"
          ></video>
        </template>
        <template v-else-if="item.materialType==='3'">
          <mk-image :src="filesImages[item.fileType].url" />
        </template>
      </div>
      <div class="right">
        <div
          class="title"
          :class="{emptyName:item.courseWareName===''}"
          @change="handelOnTitleChange"
        >
          <span class="title-span">课件名称：</span>
          <mk-input
            v-model.trim="item.courseWareName"
            placeholder="请输入课件名称"
            maxlength="20"
            show-word-limit
          />
        </div>
        <div class="old-title">
          <span>原{{ materialNameMap[item.materialType] }}名：</span>
          <span>{{ item.materialName }}</span>
        </div>
      </div>
    </div>
    <div class="op-line">
      <span
        v-if="item.materialType==='1'"
        class="op-item"
        @click="handelOnPreviewClick"
      >预览</span>
      <span
        v-if="item.materialType==='2'"
        class="op-item"
        @click="handelOnPlayClick"
      >播放</span>
      <span
        v-if="index"
        class="op-item"
        @click="handelOnUpClick"
      >上移</span>
      <span
        v-if="!isLast"
        class="op-item"
        @click="handelOnDownClick"
      >下移</span>
      <span
        class="op-item"
        @click="handelOnDeleteClick"
      >删除</span>
    </div>
  </div>
</template>

<script>

import FilesImages from '@/views/smart-name-card/components/card-image/files-images.js'

export default {
  name: 'ImportListItem',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      materialNameMap: {
        1: '图片文件',
        2: '视频文件',
        3: '文件'
      },
      filesImages: FilesImages
    }
  },
  methods: {
    // 标题更改事件
    handelOnTitleChange () {
      this.$emit('on-title-change', this.item)
    },
    // 预览
    handelOnPreviewClick () {
      if (this.item.materialType === '1') {
        this.$refs.mkImageRef.$children[0].clickHandler()
      } else {
        this.$emit('on-preview', this.item)
      }
    },
    // 播放
    handelOnPlayClick () {
      this.$emit('on-play', this.item)
    },
    // 上移
    handelOnUpClick () {
      this.$emit('on-up', this.item)
    },
    // 下移
    handelOnDownClick () {
      this.$emit('on-down', this.item)
    },
    // 删除
    handelOnDeleteClick () {
      this.$emit('on-delete', this.item)
    }
  }
}
</script>

<style lang='scss' scoped>
.import-list-item {
  width: 516px;
  height: 110px;
  margin-bottom: 11px;
  border-radius: 4px;
  border: 1px solid #e8e8e8;

  &:last-child {
    margin-bottom: 0;
  }

  .info-line {
    display: flex;
    height: 76px;

    .left {
      position: relative;
      width: 48px;
      height: 48px;
      margin: 12px 9px 0 12px;
      border-radius: 2px;
      overflow: hidden;

      .mk-image,
      .video {
        width: 100%;
        height: 100%;
      }

      .video {
        background-color: #000;
      }

      &::before {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
      }
    }

    .right {
      flex: 1;
      margin-top: 10px;
      margin-right: 15px;
      color: #595959;
      font-size: 13px;

      .title {
        display: flex;

        .title-span {
          width: 85px;
        }
      }

      .emptyName {
        & /deep/ .el-input__inner {
          border-color: #f56c6c;
        }
      }
    }
  }

  .op-line {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 33px;
    padding-right: 12px;
    border-top: 1px solid #e8e8e8;

    .op-item {
      margin-left: 15px;
      font-size: 13px;
      color: #009cff;

      @extend .cursor;
    }
  }
}
</style>
